// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"085c730a","574":"14602789"}[chunkId] + ".chunk.css";
};